import { defineExperiment } from "libs/state/src/lib/experiments";

/** A/B flag for the v6 pricing page. */
export const SUF_V6_LAUNCH = defineExperiment({
  key: "suf-v6-launch",
  durability: "none",
});

/** Temporary flag to gate flavour/texture preference questions in the signup flow. */
export const SUF_PREFERENCE_QUESTIONS = defineExperiment({
  key: "suf-preference-questions",
  durability: "none",
});
